export const getMenuTitle = (url = '') => {
    if (url.startsWith('/fundingSource/')) return 'detail';
    if (url.startsWith('/staff/')) return 'detail';
    if (url.startsWith('/client/')) return 'detail';
    if (url.startsWith('/bill/')) return 'detail';
    if (url.startsWith('/claim/')) return 'detail';

    // if (url.startsWith('/billedClaim/')) return 'detail';
    // if (url.startsWith('/completed-claim/')) return 'detail';

    if (url.startsWith('/invoice/')) return 'detail';
    if (url.startsWith('/claimPayment/')) return 'detail';
    if (url.startsWith('/invoicePayment/')) return 'detail';
    if (url.startsWith('/generateClaim')) return 'detail';
    if (url.startsWith('/generateInvoice')) return 'detail';
    if (url.startsWith('/timesheet/')) return 'detail';
    if (url.startsWith('/processed/')) return 'detail';
    if (url.startsWith('/resource/')) return 'detail';
    if (url.startsWith('/help-center')) return 'detail';
    if (url.startsWith('/template/')) return 'detail';
    if (url.startsWith('/create-form')) return 'detail';
    if (url.startsWith('/claim-payment/')) return 'detail';

    switch (url) {
        case '/fundingSource':
            return 'Payer';
        case '/staff':
            return 'Staff';
        case '/client':
            return 'Client';
        case '/management':
            return 'Access Management';
        case '/schedule':
            return 'Schedule';
        case '/activePayroll':
            return 'Payroll';
        case '/processedPayroll':
            return 'Payroll';
        case '/appeals':
            return 'Bills';
        case '/generateBill':
            return 'Bills';
        case '/pendingClaims':
        case '/generateClaim':
        case '/billedClaims':
            return 'Billing';

        case '/claims':
            return 'Claims';
        case '/invoices':
        case '/generateInvoice':
            return 'Invoices';

        case '/completed-claims':
            return 'Completed Claims';

        case '/claimPayments':
            return 'Claim Payments';
        case '/report':
            return 'Reports';

        case '/analytic':
            return 'Analytics';
        case '/system':
            return 'System';

        case '/practice-settings':
            return 'Practice Settings';

        case '/clinical-settings':
            return 'Clinical Settings';

        case '/overview':
            return 'Overview';

        case '/timesheet':
            return 'Payroll';

        case '/resource':
            return 'Resource Center';

        case '/library':
            return 'Library';

        case '/templates':
            return 'Templates';

        case '/wishlist':
            return 'Wishlist';

        default:
            return '';
    }
};
